import React from 'react';
import { theme } from '../theme';
import { useLanguage } from '../i18n/useLanguage';

interface DatenschutzerklaerungProps {
  onBack: () => void;
}

export default function Datenschutzerklaerung({ onBack }: DatenschutzerklaerungProps) {
  const { language } = useLanguage();

  const content = language === 'de' ? {
    title: 'Datenschutzerklärung',
    back: 'Zurück zur Startseite',
    sections: [
      {
        heading: '1. Verantwortlicher',
        body: 'David Schneider\nDrosselstraße 7\n51149 Köln\nE-Mail: david@schneider4me.de',
      },
      {
        heading: '2. Zweck der Datenverarbeitung',
        body: 'Wir verarbeiten Ihre E-Mail-Adresse zu folgenden Zwecken:\n• Zustellung des angeforderten Sovereign Cloud Bewertungsreports per E-Mail\n• Mögliche Kontaktaufnahme im Rahmen der Lead-Generierung',
      },
      {
        heading: '3. Rechtsgrundlage',
        body: 'Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO. Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie eine E-Mail an david@schneider4me.de senden.',
      },
      {
        heading: '4. Empfänger der Daten',
        body: 'Ihre Daten werden ausschließlich über folgende Auftragsverarbeiter verarbeitet:\n• Amazon Web Services (AWS) Simple Email Service (SES) — zum Versand der E-Mails\n• Amazon Web Services (AWS) DynamoDB — zur Speicherung der Lead-Daten\n\nAlle Daten werden in der AWS-Region eu-central-1 (Frankfurt) verarbeitet und gespeichert.',
      },
      {
        heading: '5. Speicherdauer',
        body: 'Ihre Daten werden für maximal 180 Tage gespeichert und danach automatisch gelöscht (TTL-basierte Löschung in DynamoDB).',
      },
      {
        heading: '6. Betroffenenrechte',
        body: 'Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:\n• Recht auf Auskunft (Art. 15 DSGVO)\n• Recht auf Löschung (Art. 17 DSGVO)\n• Recht auf Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO)\n• Recht auf Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)\n\nZur Ausübung Ihrer Rechte wenden Sie sich bitte an: david@schneider4me.de',
      },
      {
        heading: '7. Keine Weitergabe an Dritte',
        body: 'Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht, mit Ausnahme der oben genannten Auftragsverarbeiter (AWS SES und DynamoDB), die Ihre Daten ausschließlich in unserem Auftrag und nach unserer Weisung verarbeiten.',
      },
    ],
  } : {
    title: 'Privacy Policy',
    back: 'Back to Home',
    sections: [
      {
        heading: '1. Data Controller',
        body: 'David Schneider\nDrosselstraße 7\n51149 Köln, Germany\nEmail: david@schneider4me.de',
      },
      {
        heading: '2. Purpose of Data Processing',
        body: 'We process your email address for the following purposes:\n• Delivery of the requested Sovereign Cloud Assessment Report via email\n• Potential follow-up contact as part of lead generation',
      },
      {
        heading: '3. Legal Basis',
        body: 'Processing is based on your consent pursuant to Art. 6(1)(a) GDPR. You may withdraw your consent at any time with future effect by sending an email to david@schneider4me.de.',
      },
      {
        heading: '4. Data Recipients',
        body: 'Your data is processed exclusively through the following processors:\n• Amazon Web Services (AWS) Simple Email Service (SES) — for sending emails\n• Amazon Web Services (AWS) DynamoDB — for storing lead data\n\nAll data is processed and stored in the AWS region eu-central-1 (Frankfurt, Germany).',
      },
      {
        heading: '5. Data Retention',
        body: 'Your data is stored for a maximum of 180 days and is automatically deleted thereafter (TTL-based deletion in DynamoDB).',
      },
      {
        heading: '6. Your Rights',
        body: 'You have the following rights regarding your personal data:\n• Right of access (Art. 15 GDPR)\n• Right to erasure (Art. 17 GDPR)\n• Right to withdraw consent (Art. 7(3) GDPR)\n• Right to lodge a complaint with a supervisory authority (Art. 77 GDPR)\n\nTo exercise your rights, please contact: david@schneider4me.de',
      },
      {
        heading: '7. No Disclosure to Third Parties',
        body: 'Your data will not be disclosed to third parties, except for the processors mentioned above (AWS SES and DynamoDB), which process your data exclusively on our behalf and under our instructions.',
      },
    ],
  };

  return (
    <div style={{ background: theme.bg, minHeight: '100vh', padding: '40px 20px' }}>
      <div style={{ maxWidth: 700, margin: '0 auto' }}>
        <button
          onClick={onBack}
          style={{
            border: `1px solid ${theme.border}`,
            borderRadius: 3,
            padding: '6px 14px',
            background: '#fff',
            cursor: 'pointer',
            color: theme.text,
            marginBottom: 24,
          }}
        >
          ← {content.back}
        </button>

        <h1 style={{ fontSize: '1.5rem', color: theme.text, borderBottom: `2px solid ${theme.border}`, paddingBottom: 8 }}>
          {content.title}
        </h1>

        {content.sections.map((section, i) => (
          <div key={i} style={{ marginBottom: 24 }}>
            <h2 style={{ fontSize: '1.1rem', color: theme.text, marginBottom: 8 }}>{section.heading}</h2>
            <p style={{ color: theme.text, lineHeight: 1.6, whiteSpace: 'pre-line', margin: 0 }}>
              {section.body}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
